export const defaultTheme = {
  colors: {
    primary: {
      0: "#C7DEF6 ",
      1: "#78AEE6 ",
      2: "#4E93DB",
      3: "#0C6ACB",
      4: "#084C93"
    },
    primaryText: {
      white: "#FFFFFF",
      0: "#F8F9FA",
      1: "#F1F3F5",
      2: "#E9ECEF",
      3: "#DEE2E6",
      4: "#CED4DA",
      5: "#ADB5BD",
      6: "#868E96",
      7: "#495057",
      8: "#343A40",
      9: "#212529"
    },
    warning: {
      0: "#FFF9DB",
      1: "#FFF3BF",
      2: "#FFEC99",
      3: "#FFE066",
      4: "#FFD43B",
      5: "#FCC419",
      6: "#FAB005",
      7: "#F59F00",
      8: "#F08C00",
      9: "#E67700"
    },
    danger: {
      0: "#FFF5F5",
      1: "#FFE3E3",
      2: "#FFC9C9",
      3: "#FFA8A8",
      4: "#FF8787",
      5: "#FF6B6B",
      6: "#FA5252",
      7: "#F03E3E",
      8: "#E03131",
      9: "#C92A2A"
    },
    success: {
      0: "#E6FCF5",
      1: "#C3FAE8",
      2: "#96F2D7",
      3: "#63E6BE",
      4: "#38D9A9",
      5: "#20C997",
      6: "#12B886",
      7: "#0CA678",
      8: "#099268",
      9: "#087F5B"
    }
  }
};

export type ColorsType = typeof defaultTheme.colors;
